<template>
  <div>
    <Row style="border-left: 5px solid #009688;margin-bottom: 5px">
      <Col span="4">昨日余额: <Tag color="error">{{ countData.yesterday_balance }} 元</Tag>
      </Col>
      <Col span="4">今日余额: <Tag color="error">{{ countData.today_balance }} 元</Tag>
      </Col>
      <Col span="4">昨日消费: <Tag color="error">{{ countData.yesterday_consume }} 元</Tag>
      </Col>
      <Col span="4">今日充值: <Tag color="error">{{ countData.today_money }} 元</Tag>
      </Col>
    </Row>
    <pageTable ref="table" :tableTitle="tableColumn" :searchData="searchData" :doneFunction="doneFunction"
      :currentPageSize="10" tableApi="admin/site_balance/getList">
      <template v-slot:searchFormItem>
        <FormItem prop="gas_name">
          <Input type="text" v-model="searchData.gas_name" placeholder="油站名称" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="salesman">
          <Select v-model="searchData.salesman" placeholder="业务员" class="lx-search-item" clearable filterable>
            <Option v-for="salesman in salesmanList" :value="salesman" :key="salesman">{{ salesman }}</Option>
          </Select>
        </FormItem>
        <FormItem prop="type">
          <Select v-model="searchData.type" placeholder="油站类型" :filterable="true">
            <Option value="0" on-change>全部</Option>
            <Option value="oil_station" on-change>油站</Option>
            <Option value="lng_station">气站</Option>
          </Select>
        </FormItem>
        <FormItem prop="date">
          <DatePicker v-model="searchData.date" type="datetime" @on-change="setDefaultTime" placeholder="计算余额截至日期"
            class="lx-search-item" style="width: 180px;" />
        </FormItem>
        <FormItem prop="is_del">
          <Select v-model="searchData.status" placeholder="状态" clearable>
            <Option value="1">正常</Option>
            <Option value="-1">预警</Option>
          </Select>
        </FormItem>
      </template>
      <template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" @click="showEditDrawer(0)">添加</Button>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="exportData">导出</Button>
        </FormItem>
        <FormItem>
          <Input v-model="avgDays" style="width:120px" placeholder="天数" @input="onAvgDaysInput" @on-blur="onAvgDaysBlur"/>
        </FormItem>
        <FormItem>
          <Button type="default" @click="fetchRefillStatsManually">更新平均</Button>
        </FormItem>
      </template>
    </pageTable>
    <Modal v-model="unitPriceModal.isShow" :title="unitPriceModal.title" :loading="unitPriceModal.isLoading"
      @on-ok="changeUnitPriceFixTime" @on-cancel="cancelUnitPriceModal">
      <Form ref="unitPriceForm" :label-width="100" :model="unitPriceForm">
        <FormItem label="充值金额" prop="balances">
          <Input v-model="unitPriceForm.balances" placeholder="" maxlength="100"></Input>
        </FormItem>
        <FormItem label="增加/减少" prop="type">
          <Select v-model="unitPriceForm.type" :filterable="true">
            <Option value="1" on-change>增加</Option>
            <Option value="0">减少</Option>
          </Select>
        </FormItem>
        <FormItem label="备注" prop="remarks">
          <Input v-model="unitPriceForm.remarks" placeholder="" maxlength="100"></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 返利 -->
    <Modal v-model="rebateModal.isShow" :title="rebateModal.title" :loading="rebateModal.isLoading" @on-ok="add"
      @on-cancel="cancelUnitPriceModal">
      <Form ref="rebateForm" :label-width="100" :model="rebateForm">
        <FormItem prop="rebate">
          <Select v-model="rebateForm.rebate" placeholder="返利" clearable multiple>
            <Option v-for="(item, key) in rebate" :value="item.id" :key="key">{{ item.title }}</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="unitPriceModals.isShow" :title="unitPriceModals.title" :loading="unitPriceModals.isLoading"
      @on-ok="balanceSecWrite" @on-cancel="cancelUnitPriceModals">
      <Form ref="unitPriceForm" :label-width="100" :model="unitPriceForm">
        <FormItem label="核销金额" prop="write_balance">
          <Input v-model="unitPriceForm.write_balance" placeholder="请输入核销金额" @input="onWriteBalanceInput" @on-blur="onWriteBalanceBlur"></Input>
        </FormItem>
      </Form>
    </Modal>
    <edit-form v-if="showEdit" :show-edit="showEdit" :id="editId" :type="stype" ref="editModel"
      @cancel-edit="closeEditDrawer" @edit-success="editSuccess">
    </edit-form>
    <!--    显示可加油站点列表-->
    <Drawer :title="companyStationModal.company_name" width="1600" :value="companyStationModal.isShow"
      :mask-closable="true" @on-close="companyStationModal.isShow = false">
      <CompanyStation :company-id="companyStationModal.company_id" :station_id="companyStationModal.station_id"
        v-if="companyStationModal.isShow"></CompanyStation>
    </Drawer>
  </div>
</template>

<script>
import pageTable from "@/components/table/pageTable";
import XLSX from 'xlsx'
import editForm from "./edit";
import CompanyStation from "./companyStation";
export default {
  name: "lists",
  components: { pageTable, editForm, CompanyStation },
  data() {
    return {
      threshold: 3000, // 阈值设置为 3000
      showEdit: false,
      editId: 0,
      stype: 0,
      rebate: [], // 返利列表
      salesmanList: [],// 添加业务员列表
      searchData: {
        mobile: '',
        name: '',
        day: '',
        type: '',
        gas_name: '',
        station_id: '',
        create_time: '',
        self_support: '',
        platform: '',
        provinceDone: '',
        piaodian: 0,
        status: '1',
        key: '',
        salesman: ''

      },
      companyStationModal: {
        isShow: false,
        company_id: 0,
        company_name: '',
        station_id: '',
      },
      unitPriceModals: {
        isShow: false,
        title: '',
        isLoading: false,
      },
      unitPriceModal: {
        isShow: false,
        title: '',
        isLoading: false,
      },
      unitPriceForm: {
        station_id: 0,
        remarks: '',
        balances: 0,
        type: '1',
        write_balance: 0
      },
      rebateForm: {
        station_id: 0,
        rebate: 0,
        balances: 0,
        type: '1',
      },
      rebateModal: {
        isShow: false,
        title: '',
        rebate: 0,
        isLoading: false,
      },
      countData: {},
      avgDays: 7, // 默认往前计算天数
      refillStats: {}, // 补充统计数据映射
      tableColumn: [
        {
          title: 'ID', key: 'station_id', align: "center", width: 100, render: (h, params) => {
            return h('div', [
              h('p', params.row.station_id),
              h('Tag', { props: { color: 'orange' } }, params.row.platform),
            ])
          }
        },
        {
          title: '油站名称', key: 'gas_name', minWidth: 160, align: "left", render: (h, params) => {
            return h('div', [
              h('Tag', { props: { color: 'orange' } }, params.row.station_type_name),
              h('span', params.row.gas_name),
            ])
          }
        },
        {
          title: '余额',
          key: 'balance',
          render: (h, params) => {
            let balance = params.row.balance
            let warning = parseInt(params.row.warning)
            if (warning === 0) {
              return h('span', {
                style: {
                  color: 'red'
                }, on: { click: () => { this.showUnitPriceModal(params.row) } }
              }, balance);
            } else {
              return h('span', {
                style: {
                  color: '#2d8cf0'
                }, on: { click: () => { this.showUnitPriceModal(params.row) } }
              }, balance);
            }
          }
        },
        {
          title: '最新加注记录距今', key: 'last_refill', align: "center", render: (h, params) => {
            let row = params.row || {}
            let days = row._last_refill_days
            if ((days === undefined || days === null) && row.last_refill_time) {
              try {
                let diff = Math.floor((Date.now() - new Date(row.last_refill_time).getTime()) / (1000 * 60 * 60 * 24))
                days = diff
              } catch (e) {
                days = null
              }
            }
            return h('span', days !== undefined && days !== null ? (days + '天') : '无')
          }
        },
        {
          title: '平均每天加注金额', key: 'avg_refill', align: "center", render: (h, params) => {
            let row = params.row || {}
            let avg = row._avg_refill !== undefined ? row._avg_refill : (row.avg_refill || 0)
            return h('span', avg !== null && avg !== undefined ? avg : '--')
          }
        },
        {
          title: '返利', key: 'title', render: (h, params) => {
            return h('div', [
              h('Button', {
                on: { click: () => { this.showRebateModal(params.row) } }
              }, '设置'),
              h('Tag', { props: { color: 'orange' } }, params.row.title),
            ])
          }
        },
        { title: '充值要求(备注)', key: 'remarks', align: "center" },
        { title: '对公信息', key: 'corporate', align: "center" },
        { title: '业务员', key: 'salesman', align: "center" },
        {
          title: '核销余额',
          key: 'write_balance',
          render: (h, params) => {
            let write_balance = params.row.write_balance
            return h('span', {
              style: {
                color: '#2d8cf0'
              }, on: { click: () => { this.showUnitPriceModals(params.row) } }
            }, write_balance);
          }
        },
        {
          title: '差值', key: 'diff_balance', align: 'center', render: (h, params) => {
            let diff_balance = params.row.diff_balance
            return h('span', {
              style: {
                color: '#2d8cf0'
              }
            }, diff_balance);
          }
        },
        {
          title: '记录', align: "center", render: (h, params) => {
            let row = params.row || {}
            const fmt = (t) => {
              try {
                const d = new Date(t)
                if (isNaN(d.getTime())) return '无'
                const pad = (n) => (n < 10 ? '0' + n : n)
                return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
              } catch (e) {
                return '无'
              }
            }
            return h('div', [
              h('Button',
                {
                  props: { type: 'primary', size: 'small' },
                  on: {
                    click: () => { this.showStation(row) }
                  },
                }, '查看'),
              h('div', { style: { marginTop: '6px', color: '#999', fontSize: '12px' } }, '最近核销: ' + (row.last_write_time ? fmt(row.last_write_time) : '无'))
            ])
          }
        },
        {
          title: '操作', align: 'center', render: (h, params) => {
            let content = [];
            content.push(h('Button', {
              props: { type: 'primary', size: 'small', },
              style: { marginLeft: '5px' },
              on: {
                click: () => { this.showEditDrawer(params.row.station_id) }
              }
            }, '编辑'))
            content.push(h('Button', {
              props: { type: 'error', size: 'small', },
              style: { marginLeft: '5px' },
              on: {
                click: () => { this.del(params.row.station_id) }
              }
            }, '删除'))
            return h('div', content)
          }
        },
      ],
      total: 20, // 总数据量，用于分页
      pageSize: 10, // 每页显示的数据量
      currentPage: 1, // 当前页码
    }
  },
  methods: {
    sanitizeNumericText(val, allowNegative = false) {
      let text = val === undefined || val === null ? '' : String(val)
      text = text.replace(allowNegative ? /[^\d.\-]/g : /[^\d.]/g, '')
      if (allowNegative) {
        text = text.replace(/(?!^)-/g, '')
      }
      const parts = text.split('.')
      if (parts.length > 2) {
        text = `${parts.shift()}.${parts.join('')}`
      }
      if (text.startsWith('.')) text = `0${text}`
      if (text.startsWith('-.')) text = text.replace('-.', '-0.')
      return text
    },
    formatMoneyInput(val, allowNegative = false) {
      const text = this.sanitizeNumericText(val, allowNegative)
      if (!text) return ''
      const num = Number(text)
      if (Number.isNaN(num)) {
        this.$Message.warning('请输入数字金额')
        return ''
      }
      return num.toFixed(2)
    },
    onAvgDaysInput(val) {
      this.avgDays = this.sanitizeNumericText(val, false)
    },
    onAvgDaysBlur() {
      if (this.avgDays === '' || this.avgDays === null || this.avgDays === undefined) {
        this.avgDays = '7'
        return
      }
      let num = parseInt(String(this.avgDays), 10)
      if (Number.isNaN(num)) {
        this.$Message.warning('天数请输入整数')
        num = 7
      }
      if (num < 1) {
        this.$Message.info('天数最小为1，已自动调整')
        num = 1
      }
      if (num > 365) {
        this.$Message.info('天数最大为365，已自动调整')
        num = 365
      }
      this.avgDays = String(num)
    },
    onWriteBalanceInput(val) {
      this.unitPriceForm.write_balance = this.sanitizeNumericText(val, true)
    },
    onWriteBalanceBlur() {
      const current = this.unitPriceForm.write_balance
      if (current === '' || current === null || current === undefined) return
      this.unitPriceForm.write_balance = this.formatMoneyInput(current, true)
    },
    setDefaultTime(date) {
      if (date) {
        try {
          // 创建新的 Date 对象确保类型正确
          let newDate = new Date(date);
          if (newDate instanceof Date && !isNaN(newDate)) {
            newDate.setHours(23, 59, 59, 999);
            this.$set(this.searchData, 'date', newDate);
          }
        } catch (e) {
          console.error('Error setting default time:', e);
        }
      }
    },
    exportData() {
      this.$commonFun.postProxy('admin/site_balance/exportStationInfo', this.searchData).then((res) => {
        this.$commonFun.dealApiResult(res, () => {
          let worksheet = XLSX.utils.aoa_to_sheet(res.data)
          let workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook, worksheet, 'sheet1')
          XLSX.writeFile(workbook, `站点信息.xlsx`)
        })
      })
    },
    showEditDrawer(id) {
      this.showEdit = true;
      this.editId = id
      if (id > 0) {
        this.stype = 2//编辑
      } else {
        this.stype = 1//新增
      }

    },
    closeEditDrawer() {
      this.showEdit = false
      this.editId = 0
    },
    editSuccess() {
      this.$refs.table.getLists();
      this.showEdit = false
    },
    cancelUnitPriceModal() {
      this.unitPriceModal.isShow = false
      this.unitPriceForm.station_id = 0
      this.unitPriceForm.balances = ''
    },
    cancelUnitPriceModals() {
      this.unitPriceModals.isShow = false
      this.unitPriceForm.station_id = 0
      this.unitPriceForm.balances = ''
    },
    showUnitPriceModal(company_info) {
      this.unitPriceModal.isShow = true
      this.unitPriceModal.title = '充值'
      this.unitPriceForm.station_id = company_info.station_id
      // this.unitPriceForm.balances = company_info.balance
      this.unitPriceForm.balances = ''
    },

    showUnitPriceModals(company_info) {
      this.unitPriceModals.isShow = true
      this.unitPriceModals.title = '充值'
      this.unitPriceForm.station_id = company_info.station_id
      // this.unitPriceForm.balances = company_info.balance
      this.unitPriceForm.balances = ''
    },

    showRebateModal(company_info) {
      this.rebateModal.isShow = true
      this.rebateForm.title = '返利'
      this.rebateForm.station_id = company_info.station_id
      // this.unitPriceForm.balances = company_info.balance
      // this.unitPriceForm.balances = ''
    },
    async changeUnitPriceFixTime() {
      let res = await this.$commonFun.postProxy('admin/site_balance/setBalance', this.unitPriceForm);
      this.$commonFun.dealApiResult(res, () => {
        this.$commonFun.successTip(res.msg, () => {
          this.unitPriceModal.isShow = false
          this.unitPriceForm.station_id = 0
          this.unitPriceForm.balances = ''
          this.$refs.table.getLists();
          this.$commonFun.successTip(res.msg)
          // this.$refs.table.getLists();
        })
      })
    },
    async balanceSecWrite() {
      const writeBalance = Number(this.unitPriceForm.write_balance)
      if (Number.isNaN(writeBalance)) {
        return this.$commonFun.errorTip('请输入正确的核销金额')
      }
      let res = await this.$commonFun.postProxy('admin/site_balance/writeRecord', {
        ...this.unitPriceForm,
        write_balance: writeBalance
      });
      this.$commonFun.dealApiResult(res, () => {
        this.$commonFun.successTip(res.msg, () => {
          this.unitPriceModals.isShow = false
          this.unitPriceForm.station_id = 0
          this.unitPriceForm.balances = ''
          this.$refs.table.getLists();
          this.$commonFun.successTip(res.msg)
          // this.$refs.table.getLists();
        })
      })
    },
    async add() {
      let res = await this.$commonFun.postProxy('admin/Rebate/addStationRebate', this.rebateForm);
      this.$commonFun.dealApiResult(res, () => {
        this.$commonFun.successTip(res.msg, () => {
          this.rebateModal.isShow = false
          this.rebateForm.station_id = 0
          this.rebateForm.balances = ''
          this.$refs.table.getLists();
          this.$commonFun.successTip(res.msg)
          // this.$refs.table.getLists();
        })
      })
    },

    async del(id) {
      this.$Modal.confirm({
        content: `确定要删除吗？`,
        loading: true,
        onOk: async () => {
          let res = await this.$commonFun.postProxy('admin/site_balance/getDel', { id });
          this.$Modal.remove()
          this.$refs.table.getLists();
          this.$commonFun.successTip(res.msg)

        },
      })



    },
    async setPromoteFee(row) {
      let res = await this.$commonFun.postProxy('admin/site_balance/setBalance', { station_id: row.station_id, balance: row.balance })
      this.$commonFun.dealApiResult(res)
      this.$set(row, '$isEdit', false)
    },
    showStation(info) {
      this.companyStationModal.isShow = true
      // this.companyStationModal.company_id = info.company_id
      // this.companyStationModal.company_name = info.company_name
      this.companyStationModal.station_id = info.station_id
      this.companyStationModal.station_id = info.station_id
      //  console.log( info)


    },
    async initPage() {
      let res = await this.$commonFun.postProxy('admin/Rebate/getList', {});
      this.rebate = res.data
      // let res2 = await this.$commonFun.postProxy('admin/gas/getAllProvinceData',{});
      // this.provinceData = res2.data
    },

    updatePagination() {
      this.total = 20; // 更新总条目数
      this.pageSize = 10; // 更新每页条目数
    },
    doneFunction(res) {
      this.countData = res.extra
    },

    async fetchRefillStats(ids, lists) {
      // 调用后端接口获取每个站点的 last_refill_time, total_refill, avg_daily_refill, last_write_time 等
      let params = { ids: (ids || []).join(','), days: Number(this.avgDays) || 7 }
      if (this.searchData.date) params.date = this.searchData.date
      let res = await this.$commonFun.postProxy('admin/site_balance/getRefillStats', params)
      try {
        if (!res) return this.$commonFun.dealApiResult(res)
        if (res.code !== 200) return this.$commonFun.dealApiResult(res)

        const raw = res.data
        let data = []
        if (Array.isArray(raw)) {
          data = raw
        } else if (raw && typeof raw === 'object' && typeof raw.length === 'number') {
          try {
            data = Array.prototype.slice.call(raw)
          } catch (e) {
            data = Object.keys(raw).map(k => raw[k])
          }
        } else if (raw) {
          data = [raw]
        }

        const map = {}
        for (let i = 0; i < data.length; i++) {
          const item = data[i]
          if (item && item.station_id !== undefined) map[item.station_id] = item
        }

        // 合并到列表行上，逐行保护性处理，避免单条数据异常影响整体
        (lists || []).forEach(row => {
          try {
            const info = map[row.station_id] || {}
            this.$set(row, 'last_refill_time', info.last_refill_time || row.last_refill_time || null)

            // 计算距今天数，优先使用后端返回的数值
            if (info.last_refill_days !== undefined && info.last_refill_days !== null) {
              this.$set(row, '_last_refill_days', info.last_refill_days)
            } else {
              const t = info.last_refill_time || row.last_refill_time
              if (t) {
                const ts = new Date(t).getTime()
                if (!isNaN(ts)) {
                  const diff = Math.floor((Date.now() - ts) / (1000 * 60 * 60 * 24))
                  this.$set(row, '_last_refill_days', diff)
                } else {
                  this.$set(row, '_last_refill_days', null)
                }
              } else {
                this.$set(row, '_last_refill_days', null)
              }
            }

            // 计算平均值，优先使用后端 avg_daily_refill
            if (info.avg_daily_refill !== undefined && info.avg_daily_refill !== null) {
              this.$set(row, '_avg_refill', info.avg_daily_refill)
            } else if (info.total_refill !== undefined && info.total_refill !== null) {
              const total = parseFloat(info.total_refill)
              const days = Number(this.avgDays) || 1
              if (isFinite(total) && days > 0) {
                const avg = total / days
                this.$set(row, '_avg_refill', Number.isFinite(avg) ? avg.toFixed(2) : null)
              } else {
                this.$set(row, '_avg_refill', null)
              }
            } else {
              this.$set(row, '_avg_refill', null)
            }

            this.$set(row, 'last_write_time', info.last_write_time || row.last_write_time || null)
          } catch (e) {
            console.warn('fetchRefillStats: row merge error', e, row)
          }
        })

        // 更新 pageTable 的 dataLists
        if (this.$refs.table) {
          this.$refs.table.dataLists = lists
        }
        this.refillStats = map
      } catch (err) {
        console.error('fetchRefillStats processing error', err, res)
      }
    },

    fetchRefillStatsManually() {
      try {
        let lists = this.$refs.table && this.$refs.table.dataLists || []
        let ids = (lists || []).map(i => i.station_id).filter(i => i)
        if (ids.length) this.fetchRefillStats(ids, lists)
      } catch (e) {
        console.error(e)
      }
    },

    async getSalesMan() { // 获取业务员
      let res = await this.$commonFun.postProxy('admin/site_balance/getSalesMan', {});
      this.$commonFun.dealApiResult(res, () => {
        this.salesmanList = res.data || [];
      });
    }
    ,
    formatDateShort(val) {
      if (!val) return '无'
      try {
        const d = new Date(val)
        if (isNaN(d.getTime())) return '无'
        const pad = (n) => (n < 10 ? '0' + n : n)
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
      } catch (e) {
        return '无'
      }
    },
  },
  watch: {
    avgDays(newVal) {
      const days = parseInt(String(newVal || ''), 10)
      this.$set(this.searchData, 'days', Number.isNaN(days) ? 7 : days)
      if (this.$refs.table) {
        this.$refs.table.getLists()
      }
    }
  },

  mounted() {
    // 确保搜索参数里包含 days，让后端 getList 返回合并统计
    this.$set(this.searchData, 'days', this.avgDays)
    this.initPage();
    this.updatePagination(); // 在组件挂载后更新分页设置
    this.getSalesMan();//获取业务员

  },
}
</script>

<style scoped></style>
